/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListClusterOrgsAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ListClusterOrgsAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsAuthClusterResponse429ResponseBodyData;

  constructor(
    err: ListClusterOrgsAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListClusterOrgsAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ListClusterOrgsAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsAuthClusterResponse409ResponseBodyData;

  constructor(
    err: ListClusterOrgsAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListClusterOrgsAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ListClusterOrgsAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsAuthClusterResponse404ResponseBodyData;

  constructor(
    err: ListClusterOrgsAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListClusterOrgsAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListClusterOrgsAuthClusterResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsAuthClusterResponseResponseBodyData;

  constructor(
    err: ListClusterOrgsAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListClusterOrgsAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListClusterOrgsAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsAuthClusterResponseBodyData;

  constructor(
    err: ListClusterOrgsAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type ListClusterOrgsResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListClusterOrgsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListClusterOrgsResponseBodyData;

  constructor(
    err: ListClusterOrgsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterOrgsResponseBody";
  }
}

/** @internal */
export const ListClusterOrgsAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterOrgsAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterOrgsAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterOrgsAuthClusterResponse429ResponseBody
  > = z.instanceof(ListClusterOrgsAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterOrgsAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterOrgsAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterOrgsAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterOrgsAuthClusterResponse409ResponseBody
  > = z.instanceof(ListClusterOrgsAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterOrgsAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterOrgsAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterOrgsAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterOrgsAuthClusterResponse404ResponseBody
  > = z.instanceof(ListClusterOrgsAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterOrgsAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterOrgsAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterOrgsAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    ListClusterOrgsAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterOrgsAuthClusterResponseResponseBody
  > = z.instanceof(ListClusterOrgsAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterOrgsAuthClusterResponseBody$inboundSchema: z.ZodType<
  ListClusterOrgsAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListClusterOrgsAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListClusterOrgsAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsAuthClusterResponseBody$outboundSchema: z.ZodType<
  ListClusterOrgsAuthClusterResponseBody$Outbound,
  z.ZodTypeDef,
  ListClusterOrgsAuthClusterResponseBody
> = z.instanceof(ListClusterOrgsAuthClusterResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ListClusterOrgsResponseBody$inboundSchema: z.ZodType<
  ListClusterOrgsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListClusterOrgsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListClusterOrgsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterOrgsResponseBody$outboundSchema: z.ZodType<
  ListClusterOrgsResponseBody$Outbound,
  z.ZodTypeDef,
  ListClusterOrgsResponseBody
> = z.instanceof(ListClusterOrgsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
